<app-navbar-style-two></app-navbar-style-two>
<div class="privacy-policy-section">
  <div class="container">
    <div class="policy-header">
  <span class="policy-badge">📜 Terms & Conditions</span>

  <h1>Sangeetha Toys</h1>

  <p>
    Welcome to Sangeetha Toys. By accessing our website and purchasing
    products from us, you agree to comply with and be bound by the
    following terms and conditions. Please read them carefully before
    placing an order.
  </p>
</div>

   <div class="policy-content">

  <div class="policy-item">
    <h4>1. Product Information</h4>
    <ul>
      <li>We strive to provide accurate descriptions, images, pricing, and availability for all toys.</li>
      <li>Product colors and packaging may vary slightly from images displayed on the website.</li>
      <li>Recommended age groups are provided for guidance and should be followed for child safety.</li>
    </ul>
  </div>

  <div class="policy-item">
    <h4>2. Orders & Pricing</h4>
    <ul>
      <li>All prices are displayed in INR and include applicable taxes unless stated otherwise.</li>
      <li>Prices, promotions, and discounts may change without prior notice.</li>
      <li>Orders are confirmed only after successful payment verification.</li>
    </ul>
  </div>

  <div class="policy-item">
    <h4>3. Shipping & Delivery</h4>
    <ul>
      <li>Delivery timelines vary based on location and product availability.</li>
      <li>Shipping charges, if applicable, will be displayed during checkout.</li>
      <li>Customers should inspect products upon delivery and report damages within 24 hours.</li>
    </ul>
  </div>

  <div class="policy-item">
    <h4>4. Returns & Exchanges</h4>
    <ul>
      <li>Returns and exchanges are subject to our return policy.</li>
      <li>Products must be unused and returned in their original packaging.</li>
      <li>Customized or clearance-sale products may not be eligible for return.</li>
    </ul>
  </div>

  <div class="policy-item">
    <h4>5. Payment Terms</h4>
    <ul>
      <li>We accept UPI, credit/debit cards, net banking, and other supported payment methods.</li>
      <li>All transactions are processed through secure payment gateways.</li>
    </ul>
  </div>

  <div class="policy-item">
    <h4>6. Intellectual Property</h4>
    <ul>
      <li>All website content, logos, images, product descriptions, and designs are the property of Sangeetha Toys.</li>
      <li>Unauthorized use, reproduction, or distribution is strictly prohibited.</li>
    </ul>
  </div>

  <div class="policy-item">
    <h4>7. Governing Law</h4>
    <ul>
      <li>These terms are governed by the laws of India.</li>
      <li>Any disputes arising from the use of this website shall be subject to the jurisdiction of local courts.</li>
    </ul>
  </div>

</div>
  
  </div>
</div>
